import { createSelector } from 'reselect';
import { filter, get, lte, map, placeholder, some, values, where, equals } from 'lodash/fp';

import playerSwapSelectedPlayerSelector from './playerSwapSelectedPlayerSelector';

const notEqual = val => x => x !== val;
const annotatePlayers = map(p => ({
  ...p,
  teamAbbr: p.isHome ? p.homeAbbr : p.awayAbbr
}));

function getOtherPlayers(playerPool, isRacing, selectedPlayer) {
  const players = annotatePlayers(values(playerPool)).filter(p => !p.isLocked);

  if (!selectedPlayer) {
    return players;
  }

  const conditions = {
    id: notEqual(selectedPlayer.id),
    positions: some({ key: selectedPlayer.positionId }),
    salary: lte(placeholder, selectedPlayer.salary)
  };

  if (isRacing) {
    conditions.gameId = equals(selectedPlayer.gameId);
  }

  return filter(where(conditions), players);
}

const playerSwapOtherPlayersSelector = createSelector(
  get('playerSwap.playerPool'),
  get('playerSwap.selectedSlate.isRacing'),
  playerSwapSelectedPlayerSelector,
  getOtherPlayers
);

export default playerSwapOtherPlayersSelector;
